import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "page" }

import { onMounted, nextTick } from "vue";
import { useSdkStore } from "@/stores/sdk";
import { initSdk } from "@/sdk/init";

import { useRouter, useRoute } from "vue-router";
import { initDesign } from '@/common/initDesign'
import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'design',
  setup(__props) {

const router = useRouter();
const route = useRoute()
const sdkStore = useSdkStore();
const userStore = useUserStore()
const islogin = userStore.isLoggedIn
//@ts-ignore
onMounted(async () => {

  await nextTick();
  const desginsdk = await initSdk("#page", islogin);
  sdkStore.setSdk(desginsdk);
  initDesign()
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})